import React, { createContext, useContext, useEffect, useState } from 'react';
import { ErrorPage, PageLoader, useCurrentClientManager } from '@cko/dashboard-shared';

import { useIsOnboardingEnterpriseMerchant } from '../../hooks/useIsOnboardingEnterpriseMerchant';
import { UiConfig } from '../../config/shared/types/config';
import { useGetUiConfig } from './hooks/useGetUiConfig';

export const UiConfigContext = createContext<UiConfig>({
  routes: [],
  menus: {},
  pages: {},
  pathParameters: {},
  views: {},
});

export const UiConfigProvider = ({ children }: { children: React.ReactNode }) => {
  const { subEntity } = useCurrentClientManager();
  const showEnterpriseOnboardingShell = useIsOnboardingEnterpriseMerchant();

  const [uiConfigName, setUiConfigName] = useState<string | undefined>();
  const { isError, isLoading, uiConfig } = useGetUiConfig(uiConfigName);

  useEffect(() => {
    if (subEntity) {
      setUiConfigName('seller-dashboard');
      return;
    }

    if (showEnterpriseOnboardingShell) {
      setUiConfigName('onboarding');
      return;
    }

    setUiConfigName('dashboard');
  }, [showEnterpriseOnboardingShell, subEntity]);

  if (isLoading) {
    return <PageLoader />;
  }

  if (isError || !uiConfig) {
    return <ErrorPage />;
  }

  return <UiConfigContext.Provider value={uiConfig}>{children}</UiConfigContext.Provider>;
};

export const useUiConfig = () => {
  const context = useContext(UiConfigContext);
  return context;
};
